import { INE_REQUEST_START_LOADING, INE_REQUEST_END_LOADING, INE_REQUEST_LOADED, INE_REQUEST_SEARCH_START_LOADING, INE_REQUEST_SEARCH_END_LOADING, INE_REQUEST_SEARCH_LOADED, SET_INE_REQUEST_FILTER } from "../constants/IneRequestConstants";
import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIneRequest(id, navigate) {
    return async (dispatch) => {
        await dispatch({ type: INE_REQUEST_START_LOADING });
        try {
            let data = await getApiData("IneRequest/GetIneRequestFBO", { id });
            if(data.success) {
                await dispatch({
                    type: INE_REQUEST_LOADED,
                    payload: data.responseEntities[0]
                });
            } 
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
                else if(data.errorCode == "402") {
                    if(data.companyId && data.companyId > 0) {
                        navigate('/invalid-company/ine/' + data.companyId + "/" + data.moduleName + "/" + id);
                    }
                    else {
                        navigate('/invalid-company');
                        dispatch(commonActions.setErrorMessage(data.errorDesc));
                    }
                }
                else {
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
            }

            await dispatch({ type: INE_REQUEST_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_REQUEST_END_LOADING });
        }
    };
}

export function saveIneRequest(fbo, status, message, navigate, silentSave) {
    return async (dispatch) => {
        await dispatch({ type: INE_REQUEST_START_LOADING });
        try {
            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("IneRequest/SaveIneRequestFBO", { status, message }, fbo);
            if(data.success) {
                if(isAdd) {
                    navigate('/ine-request-edit/' + data.responseEntities[0].ineRequest.id);
                    dispatch(commonActions.setSuccessMessage("INE Ticket Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: INE_REQUEST_LOADED,
                        payload: data.responseEntities[0]
                    });
                    
                    if(!silentSave) {
                        dispatch(commonActions.setSuccessMessage("INE Ticket Saved Successfully!"));
                    }
                }
            } else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            await dispatch({ type: INE_REQUEST_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_REQUEST_END_LOADING });
        }
    };
}

export function approveIneRequest(ineRequestId, ineApprovalId, status, comments, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: INE_REQUEST_START_LOADING });

        try {

            var data = await postApiJsonData("IneRequest/ApproveIneRequest", { ineRequestId, ineApprovalId, status, comments }, null);
            
            if(data.success) {
                dispatch(loadIneRequest(ineRequestId, navigate));
                dispatch(commonActions.setSuccessMessage("INE Ticket " + status + " Successfully!"));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: INE_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_REQUEST_END_LOADING });
        }
    };
}

export function assignMeIneRequest(ineRequestId, userId, assignMe, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: INE_REQUEST_START_LOADING });

        try {

            var data = await postApiJsonData("IneRequest/AssignIneRequest", { ineRequestId, userId, assignMe }, null);
            
            if(data.success) {
                dispatch(loadIneRequest(ineRequestId, navigate));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: INE_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_REQUEST_END_LOADING });
        }
    };
}

export async function calculateInspector(inspector) {
    var returnData = {
        success: false,
        errorMessage: "",
        inspector: null
    };

    try {

        var data = await postApiJsonData("IneRequest/CalculateInspector", { }, inspector);

        if(data.success) {
            returnData.success = true;
            returnData.inspector = data.responseEntities[0];
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function loadIneRequestSearch(filters, navigate) {
    return async (dispatch) => {
        await dispatch({ type: INE_REQUEST_SEARCH_START_LOADING });
        try {
            var data = await postApiJsonData("IneRequest/GetPaged", filters, null);
            if(data.success) {
                await dispatch({
                    type: INE_REQUEST_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList,
                        searchList: data.responseEntities[0].userSearches,
                        totalCount: data.responseEntities[0].totalCount
                    }
                });
            } else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            await dispatch({ type: INE_REQUEST_SEARCH_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_REQUEST_SEARCH_END_LOADING });
        }
    };
}

export function downloadIneRequestSearch(filters, documentName) {
    return async (dispatch) => {
        await dispatch({ type: INE_REQUEST_SEARCH_START_LOADING });
        try {
            var data = await downloadFile("IneRequest/ExportToExcel", filters);
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a);
                a.click();
                a.remove();
            } else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            await dispatch({ type: INE_REQUEST_SEARCH_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_REQUEST_SEARCH_END_LOADING });
        }
    };
}

export function setIneRequestFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_INE_REQUEST_FILTER,
            payload: filter
        });
    };
}
